import React, { useEffect, ReactNode } from "react";
import axios from "axios";
import { BASE_URL } from "../config/api";

interface ApplicationProviderProps {
    children: ReactNode;
}

export const ApplicationProvider: React.FC<ApplicationProviderProps> = ({ children }) => {
    useEffect(() => {
        if (BASE_URL) {
            axios.defaults.baseURL = BASE_URL;
        }
    }, []);

    return <>{children}</>;
};

export default ApplicationProvider;
